import React from 'react';

/**
 * Animated beer ticker component that displays scrolling beer emojis
 */
export const BeerTicker: React.FC = () => {
  return (
    <>
      <div style={{
        position: 'absolute',
        bottom: '0.5rem',
        left: 0,
        right: 0,
        height: '5.5rem',
        paddingTop: '1rem',
        paddingBottom: '0.5rem',
        overflow: 'hidden',
      }}>
        <div style={{
          display: 'flex',
          width: 'max-content',
          animation: 'beerTicker 20s linear infinite',
          alignItems: 'center',
        }}>
          {[...Array(40)].map((_, i) => {
            const emojis = ['🍺', '🍻', '🥂', '🥃', '🍷', '🍾'];
            return (
              <span 
                key={i}
                style={{ 
                  fontSize: '2rem', 
                  padding: '0 1rem',
                  animationDelay: `${i * 0.15}s`,
                  display: 'inline-block',
                  animation: 'beerBounce 0.5s ease-in-out infinite',
                }}
              >
                {emojis[i % emojis.length]}
              </span>
            );
          })}
        </div>
      </div>
      <style>{`
        @keyframes beerTicker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes beerBounce {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          25% { transform: translateY(-12px) rotate(-8deg); }
          75% { transform: translateY(-12px) rotate(8deg); }
        }
      `}</style>
    </>
  );
};
